<template>
  <q-page class="row full-height q-col-gutter-xs">
    <div class="col-2 bg-secondary">

    </div>
    <div class="col">
      <div class="row q-col-gutter-lg q-pa-sm">
        <template v-for="p in productos" :key="p">
          <div class="col-3">
            <q-card class="my-card">
              <q-img :src="'https://picsum.photos/300/300?random=' + p">
                <div class="absolute-bottom">
                  <div class="text-h6">Our Changing Planet</div>
                  <div class="text-subtitle2">by John Doe</div>
                </div>
              </q-img>

              <q-card-actions align="right">
                <q-btn flat round icon="add_shopping_cart" />
              </q-card-actions>
            </q-card>
          </div>
        </template>

      </div>
    </div>
  </q-page>
</template>

<script lang="ts">
import { defineComponent, reactive } from 'vue';
import { Presupuesto } from './types'
export default defineComponent({
  name: 'IndexPage',
  setup() {
    const productos = [1, 2, 3, 4, 5, 6, 7, 8];
    const d = reactive<Presupuesto>({
      nombre: ''
    })
    return { d, productos };
  }
});
</script>
